module.exports = __webpack_public_path__ + "img/wechateq.2ad32e25.png";